import * as React from 'react';

import { SaveSearchProvider as Provider } from '@/packages/SaveSearchModal';
import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { useFiltersSelector } from '@/packages/redux-state/store/slices/jsonQuery';
import { useUserSelector } from '@/packages/redux-state/store/slices/user';

import { useApplicationContext } from '../../context/ApplicationContext';
import { useGetAnalyticsPage } from '../../hooks/useGetAnalyticsPage';

import { getSaveSearchMicrofrontend } from './utils/getSaveSearchMicrofrontend';

export const SaveSearchModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getSaveSearchMicrofrontend(context), [context]);

  const user = useUserSelector();
  const isAuthenticated = user?.isAuthenticated;
  const email = isAuthenticated ? user.email : null;

  const jsonQuery = useFiltersSelector();

  const { data } = useSearchOffersDesktopQuery();
  const title = data?.pages[0].seo.view.title ?? null;
  const queryString = data?.pages[0].analytics.page.queryString ?? null;

  const { pageType, listingType } = useGetAnalyticsPage();

  const params = {
    jsonQuery,
    email,
    title,
    isAuthenticated,
    source: listingType,
    analyticsParams: {
      pageType,
      listingType,
      queryString,
      isFromBanner: false,
    },
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
